import { ThemeColor } from '@/enums'
import { useFormContext, useFormItem } from '@/providers'
import { fromEventTarget, themeColorFrom } from '@/utils'
import { Textarea } from '@surein/ui'
import { TextareaHTMLAttributes, useEffect, useState } from 'react'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import { getError } from '../FormItem/helpers'

const StyledMessage = styled.p`
  cursor: inherit;
  white-space: pre-line;
  line-height: 140%;
  font-weight: 700;
  font-size: 12px;
  color: ${themeColorFrom(prop('color'))};
`

interface FormTextareaV2Props
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string
  label?: string
  disabled?: boolean
  infoMessage?: string
  showErrorMessage?: boolean
  validateOnChange?: boolean
}

export const FormTextareaV2 = ({
  name,
  disabled,
  infoMessage,
  showErrorMessage = true,
  validateOnChange = false,
  ...props
}: FormTextareaV2Props) => {
  const { validateField } = useFormContext()
  const [touched, setIsTouched] = useState(false)
  const { value, onChange, error } = useFormItem(name)
  const errorMsg = getError(error)
  const hasErrorMessage = Boolean(errorMsg && showErrorMessage)

  useEffect(() => {
    if (touched && validateOnChange && value) validateField(name)
  }, [validateOnChange, touched, value])

  return (
    <div className="flex flex-col gap-2">
      <Textarea
        disabled={disabled}
        id={name}
        isErrored={Boolean(error)}
        name={name}
        onBlur={() => touched && validateField(name)}
        onChange={fromEventTarget(onChange)}
        onFocus={() => setIsTouched(true)}
        value={value}
        {...props}
      />

      {hasErrorMessage && (
        <StyledMessage color={ThemeColor.danger2}>
          {String(errorMsg)}
        </StyledMessage>
      )}

      {infoMessage && !hasErrorMessage && (
        <StyledMessage color={ThemeColor.b50}>{infoMessage}</StyledMessage>
      )}
    </div>
  )
}
